import { skipNextRefetchForEntity } from '@/hooks/reference/useRefetchListOnReferenceVersion.js';
import { useReferenceStore } from '@/store/reference.store';
import { logReferenceDetailSync } from '@/lib/reference-sync/reference-detail-sync-debug.js';

/**
 * Local version bump after detail-page association mutation (avoids duplicate hub refetch).
 * @param {string} hubEntityKey
 * @param {string} [debugLabel]
 */
export function bumpHubEntityVersion(hubEntityKey, debugLabel) {
    skipNextRefetchForEntity(hubEntityKey);
    useReferenceStore.getState().bumpEntityVersion(hubEntityKey);
    logReferenceDetailSync('integration', 'bumpHubEntityVersion', {
        label: debugLabel,
        entity: hubEntityKey,
        version: useReferenceStore.getState().versions?.[hubEntityKey],
    });
}
